/**
 * Check if the application is running in registration-only mode
 * based on the current domain and environment configuration
 */
export const isRegistrationOnlyMode = (): boolean => {
  const registrationDomain = import.meta.env.VITE_REGISTRATION_ONLY_DOMAIN

  // If no domain is configured, registration mode is disabled
  if (!registrationDomain) {
    return false
  }

  // Check if current hostname matches the configured domain
  const currentHostname = window.location.hostname
  return currentHostname === registrationDomain
}

/**
 * Get the allowed path for registration-only mode
 */
export const getRegistrationPath = (): string => {
  return '/registration-npsn'
}
